import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './Select.module.sass';
import Tooltip from '../tooltip/Tooltip';
import arrowDownIcon from '../../../images/icons/arrow-down.svg';

const cx = classNames.bind(styles);

/** A select component with an optional label. */
class Select extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
      active: false,
    };
  }

  onChange = (event) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(event);
    }
  };

  onFocus = (event) => {
    const { onFocus } = this.props;
    this.setState({ focused: true });
    if (onFocus) {
      onFocus(event);
    }
  };

  onBlur = (event) => {
    const { onBlur } = this.props;
    this.setState({ focused: false });
    if (onBlur) {
      onBlur(event);
    }
  };

  render() {
    const {
      className,
      errorTooltipClassName,
      id,
      tabIndex = 0,
      name,
      value,
      options,
      label,
      disabled,
      error,
      defaultOption,
    } = this.props;
    const {
      focused,
      active,
    } = this.state;
    const selectCx = {
      disabled,
      focused,
      active,
      error,
    };

    return (
      <div className={cx(styles.selectContainer, className)}>
        { error
          && focused
          && (
            <Tooltip className={cx(errorTooltipClassName, styles.tooltipMargin)} type="error">
              <div>{ error }</div>
            </Tooltip>
          )}
        { label }
        <label htmlFor={id} className={cx(styles.select, selectCx)}>
          <select
            tabIndex={tabIndex}
            id={id}
            name={name}
            value={value}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            disabled={disabled}
          >
            {defaultOption}
            {
              options.map((option) => (
                <option key={option.value} value={option.value}>{ option.label }</option>
              ))
            }
          </select>
          <img src={arrowDownIcon} alt="arrow down icon" width="20px" />
        </label>
      </div>
    );
  }
}

Select.propTypes = {
  /** Any CSS classes to apply to component. */
  className: PropTypes.string,
  /** Any CSS classes to apply to component error tooltip. */
  errorTooltipClassName: PropTypes.string,
  /** Id for input. */
  id: PropTypes.string,
  /** Tab index for component's select tag. */
  tabIndex: PropTypes.number,
  /** Name for select. */
  name: PropTypes.string,
  /** Default value for select. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Options for select. */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  /** Default option for select. */
  defaultOption: PropTypes.node,
  /** Label for select. */
  label: PropTypes.string,
  /** Error text to show in tooltip above select. */
  error: PropTypes.string,
  /** Boolean indicating whether select should render as disabled. */
  disabled: PropTypes.bool,
  /** onChange handler. */
  onChange: PropTypes.func,
  /** onFocus handler. */
  onFocus: PropTypes.func,
  /** onBlur handler. */
  onBlur: PropTypes.func,
};

export default Select;
